module.exports = __webpack_public_path__ + "static/media/2015 Dublin, Ireland.10a1d128.jpg";